import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { GpAuthService } from './services/gp-auth.service';
import { GpAuthState } from './states/gp-auth/gp-auth.state';
import { GP_AUTH_CONFIG_DEFAULT, GP_AUTH_CONFIG_TOKEN, GpAuthConfigModel } from './symbols';

@NgModule({
  imports: [
    NgxsModule.forFeature([GpAuthState])
  ],
  providers: [GpAuthService]
})
export class GpAuthModule {
  static forRoot(config?: GpAuthConfigModel): ModuleWithProviders<GpAuthModule> {
    return {
      ngModule: GpAuthModule,
      providers: [
        {
          provide: GP_AUTH_CONFIG_TOKEN,
          useValue: { ...GP_AUTH_CONFIG_DEFAULT, ...config }
        }
      ]
    };
  }
}
